import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgWaveAlt = function SvgWaveAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M19.354 14.4c-1.172.062-2.28-.522-2.854-1.504a.252.252 0 00-.242-.106.245.245 0 00-.202.165L14.48 17.77c-.229.586-.818.97-1.47.958-.651-.012-1.225-.417-1.43-1.011L9.256 9.408a.249.249 0 00-.246-.178.248.248 0 00-.239.186 13.625 13.625 0 01-1.2 3.603c-.537.931-1.593 1.472-2.697 1.38H.168C1.144 19.943 6.145 24 12 24s10.856-4.057 11.832-9.6h-4.478z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M4.874 12.48c.935 0 1.012 0 1.913-3.422.206-.78.448-1.7.755-2.78.197-.61.793-1.018 1.458-.998.665-.018 1.26.394 1.454 1.005l2.4 8.57a.247.247 0 00.236.18.248.248 0 00.243-.17l1.346-4.113c.202-.553.738-.93 1.348-.95a1.537 1.537 0 011.443.743c.1.186.2.367.285.542.581 1.124.75 1.39 1.6 1.39H24C24 6.115 18.626.957 11.998.958 5.372.96 0 6.118 0 12.48h4.874z"
  }));
};

export default SvgWaveAlt;